export default function BackToTop() {
	if (!document.body.classList.contains('fundraising-toolkit-template-default')) return;

	const btn = document.querySelector('.fundraising-toolkit-btn.back-to-top');
	if (!btn) return;

	const toggle = () => {
		const isScrollable = document.documentElement.scrollHeight > window.innerHeight;
		const hasScrolled = window.scrollY > 100;
		btn.classList.toggle('is-visible', isScrollable && hasScrolled);
	};

	btn.addEventListener('click', (e) => {
		e.preventDefault();
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});

	window.addEventListener('scroll', toggle, { passive: true });
	window.addEventListener('resize', toggle, { passive: true });
	toggle();
}
